/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 17:58:59
 */ 
import {memberHomeCn} from "./memberHome/memberHomeCn.js";
import {memberOrderCn} from "./memberOrder/memberOrderCn.js";
import {memberInquirySheetCn} from "./memberInquirySheet/memberInquirySheetCn.js";
import {MemberTestingProgrammeCn} from "./MemberTestingProgramme/MemberTestingProgrammeCn.js";
import {MemberOrderEvaluationCn} from "./MemberOrderEvaluation/MemberOrderEvaluationCn.js";
import {MemberTrainCourseCn} from "./MemberTrainCourse/MemberTrainCourseCn.js";
import {MemberTrainOrderCn} from "./MemberTrainOrder/MemberTrainOrderCn.js";
import {MemberTrainEvaluationCn} from "./MemberTrainEvaluation/MemberTrainEvaluationCn.js";
import {MyConsultationCn} from "./MyConsultation/MyConsultationCn.js";
import {ConsultationOrderCn} from "./ConsultationOrder/ConsultationOrderCn.js";
import {ConsultationEvaluationCn} from "./ConsultationEvaluation/ConsultationEvaluationCn.js";
import {memberCollectionCn} from "./memberCollection/memberCollectionCn.js";
import {certificateCn} from "./certificate/certificateCn.js";
import {specimenCn} from "./specimen/specimenCn.js";
import {specimenDetailCn} from "./specimenDetail/specimenDetailCn.js";
import {vistedRecordsCn} from "./vistedRecords/vistedRecordsCn.js";
import {modifyMemberInfoCn} from "./modifyMemberInfo/modifyMemberInfoCn.js";
import {integralCn} from "./integral/integralCn.js";
import {AddressBookCn} from "./AddressBook/indexCn.js";
import {InvoiceCn} from "./Invoice/InvoiceCn.js";
export const memberCn = {
    memberHomeLang:memberHomeCn,
    memberOrderLang:memberOrderCn,
    memberInquirySheetLang:memberInquirySheetCn,
    MemberTestingProgrammeLang:MemberTestingProgrammeCn,
    MemberOrderEvaluationLang:MemberOrderEvaluationCn,
    MemberTrainCourseLang:MemberTrainCourseCn,
    MemberTrainOrderLang:MemberTrainOrderCn,
    MemberTrainEvaluationLang:MemberTrainEvaluationCn,
    MyConsultationLang:MyConsultationCn,
    ConsultationOrderLang:ConsultationOrderCn,
    ConsultationEvaluationLang:ConsultationEvaluationCn,
    memberCollectionLang:memberCollectionCn,
    certificateLang:certificateCn,
    specimenLang:specimenCn,
    specimenDetailLang:specimenDetailCn,
    vistedRecordsLang:vistedRecordsCn,
    modifyMemberInfoLang:modifyMemberInfoCn,
    integralLang:integralCn,
    AddressBookLang:AddressBookCn,
    InvoiceLang:InvoiceCn
}


// WEBPACK FOOTER //
// ./src/lang/member/memberCn.js